
<val-boite-dialogue-generique #boiteDialogue
                              class="val-modifier-statut-dialogue"
                              [titre]="'vente.modifier-statut.titre' | transloco"
                              [validerDesactive]="!statutSelectionne"
                              (validerClick)="Valider()"
                              (annulerClick)="Annuler()">
	<div contenu
	     class="val-modifier-statut-dialogue-contenu">
		<val-simple-libelle [libelle]="'vente.modifier-statut.statuts-disponibles' | transloco"></val-simple-libelle>
		<kendo-dropdownlist class="val-modifier-statut-dialogue-dropdown"
		                     [data]="transitions"
		                     textField="libelle"
		                     valueField="id"
		                     [valuePrimitive]="true"
		                     [popupSettings]="{ appendTo: 'component' }"
		                     [(ngModel)]="statutSelectionne">
		</kendo-dropdownlist>
		@if (CleMessageInformationStatut(); as cleMessageInformation) {
			<div class="val-modifier-statut-dialogue-info">
				<val-fonte-icone iconeCss="fas fa-info-circle"></val-fonte-icone>
				<val-simple-libelle [libelle]="cleMessageInformation | transloco"></val-simple-libelle>
			</div>
		}
	</div>
</val-boite-dialogue-generique>
<val-boite-dialogue-messages #boiteDialogueMessages></val-boite-dialogue-messages>
